/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editpicturepagedescription3Inputs */

const en_editpicturepagedescription3 = /** @type {(inputs: Editpicturepagedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload an image, crop and adjust it, then save it to your media library.`)
};

const de_editpicturepagedescription3 = /** @type {(inputs: Editpicturepagedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild hochladen, zuschneiden und anpassen, dann in deiner Mediathek speichern.`)
};

/**
* | output |
* | --- |
* | "Upload an image, crop and adjust it, then save it to your media library." |
*
* @param {Editpicturepagedescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const editpicturepagedescription3 = /** @type {((inputs?: Editpicturepagedescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editpicturepagedescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_editpicturepagedescription3(inputs)
	return de_editpicturepagedescription3(inputs)
});
export { editpicturepagedescription3 as "editPicturePageDescription" }